import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "lightning",
  "use": "lightning-usage",
  "viewBox": "0 0 17 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 24\" id=\"lightning\"><path d=\"M5.334 22.5l1.5-7.5-6-2.25 10.5-11.25-1.5 7.5 6 2.25-10.5 11.25z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/lightning.svg
// module id = UADr
// module chunks = 39 44